module.exports = __webpack_public_path__ + "static/media/bg-animalwelfare_dt.95a79f30.jpg";